import { useState, useEffect, useRef } from 'react';
import Button from '../components/Button';


import { motion, AnimatePresence } from "framer-motion"

function Theater(props) {
   
    const [windowSizeValid, setWindowSizeValid] = useState(window.innerHeight<window.innerWidth);
    const tokenNumberInput = useRef("");
    useEffect(() => {
        let timeout;
        const handleResize = () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => { 
                setWindowSizeValid(window.innerHeight<window.innerWidth);
            }, 200);
        }
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const [isLaunchEnabled, setIsLaunchEnabled] = useState(true);
    const [tokenId, setTokenId] = useState(0);
    const [hasError, setHasError] = useState(false);

    const handleTextChange = (event) => {
        setTokenId(event.target.value)
    }
    const handleRandomTokenClick = () => {
        //let id = props.data.previews[Math.floor(Math.random()*props.data.previews.length)];
        let id = 286000000 + Math.floor(Math.random()*120);
        tokenNumberInput.current.value = id;
        setTokenId(id)
    }

    const handleLaunchClick = async () => {

        if (parseFloat(tokenId)<286000000 || parseFloat(tokenId)>286000360) { 
            setHasError(true);

            console.error("Hash or id are not valid.");
            return;
        };

        // Make a request
        const response = await fetch('https://token.artblocks.io/' + tokenId);
        const responseData = await response.json();
        if (response.ok) {
            window.open(`/theater/?id=${parseFloat(responseData.tokenID)}`,"_blank");
        } else {
            setHasError(true);
            console.error(responseData.message);
            return;
        }
        // let pwd = (()=>{
        //     let x = "0123456789abcdef", hash = '0x'
        //     for (let i = 4; i > 0; --i) { hash += x[Math.floor(Math.random()*x.length)]}
        //     return hash
        // })();
        // let token = props.data.tokens.find(e=>e.id===parseFloat(tokenId));
        //setIsLaunchEnabled(false);
        props.hide();
    }
    
    // useEffect(()=> {
    //     setIsLaunchEnabled(props.data.tokens.some(e=>e.id===parseFloat(tokenId)))
    // },[tokenId]);

    return (
        <AnimatePresence>
        {props.isVisible&&(<motion.div className={`modal ${props.isVisible&&"is-active"}`} {...props.framer.fade}>
            <div className="modal-background"></div>
            <div className="modal-content">
                <div className="box">

                    <div className="content is-serif is-size-4">
                        <p className="has-text-centered is-uppercase">
                            Launch theater mode
                        </p>
                    </div>
                    {windowSizeValid?(
                    <>
                    <div className="content is-serif is-size-4">
                        <p>
                            Drifting been designed in a vertical format, but an alternative display mode is available for horizontal screens. The entire screen space is filled by putting two iterations of the same token next to each other.
                        </p>
                    </div>
                    
                   
                    <div className="field">
                        <label className="label has-text-centered is-size-7">Insert your Token ID or <span className="is-underlined is-clickable" onClick={handleRandomTokenClick}>generate a random one</span>
                        </label>
                        <div className="control ">
                            <input ref={tokenNumberInput} onChange={handleTextChange} className="input has-text-centered is-code is-size-4" type="text" placeholder="286000000" />
                        </div>
                    </div>

                    <div className="field is-grouped is-grouped-centered pt-4">
                        <div className="control">
                            <Button onClick={handleLaunchClick} disabled={!isLaunchEnabled}>Launch</Button>

                        </div>
                        <div className="control">
                            <Button onClick={props.hide}>Close</Button>
                        </div>
                        
                    </div>

                    <div className="content is-serif is-size-7 pt-4">
                        {hasError&&(<p className='has-text-centered has-text-danger	'>Invalid Token ID, try again please!</p>)}
                        <p className="has-text-centered">
                            When launched, press «F» for full screen.
                        </p>
                    </div>
                    </>
                    ):(
                    <>
                    <p className="content is-serif is-size-4 pt-4 has-text-centered">
                        The «theater» has been designed as an experience for horizontal displays and it is not available on mobile devices. <br/>
                        If you are on a computer and seeing this notice, your browser window might be too narrow. Please resize the window to continue.
                    </p>
                   

                    <div className="field is-grouped is-grouped-centered pt-4">
                        
                        <div className="control">
                            <Button onClick={props.hide}>Close</Button>
                        </div>
                    </div>
                    </>
                    )}

                </div>
            </div>
            <button className="modal-close is-large" aria-label="close" onClick={props.hide}></button>
        </motion.div>)}
        </AnimatePresence>

    )
}
export default Theater;

